import {
  put, takeEvery,
} from 'redux-saga/effects';

import {
  ACT_AUTH_LOGIN_ATTEMPT,
  ACT_AUTH_LOGIN_SUCCESS, ACT_AUTH_LOGOUT_INIT,
  ACT_AUTH_TOKEN_CHECK,
  ACT_AUTH_TOKEN_FAIL, ACT_AUTH_TOKEN_SUCCESS,
} from '../constants/actions';
import Api from '../services/Api';
import {
  loginFailedAction,
  loginSuccessAction, logoutSuccessAction,
  tokenCheckAction, tokenCheckFailAction,
  tokenCheckSuccessAction,
} from '../actions';

import cookies from '../cookies';

const { config } = window;

function* logout() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('expires_at');
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  cookies.set('access_token', 'x');
  yield put(logoutSuccessAction());
}

function* deleteToken() {
  yield localStorage.removeItem('access_token');
}

function* checkAuth() {
  const cookiesCheck = cookies.getAll().access_token;
  if (cookiesCheck !== undefined && cookiesCheck !== null && cookiesCheck !== '') {
    localStorage.setItem('access_token', cookiesCheck);
  }

  const accessToken = localStorage.getItem('access_token');

  if (accessToken === undefined || accessToken === null) {
    yield put(tokenCheckFailAction());
  } else {
    const { status, data } = yield Api.get('me', false);
    if (status === 200) {
      yield put(tokenCheckSuccessAction(accessToken, data));
    } else {
      yield put(tokenCheckFailAction());
    }
  }
}

function* attemptLogin(action) {
  const requestData = {
    grant_type: 'password',
    client_id: config.client_id,
    client_secret: config.client_secret,
    username: action.username,
    password: action.password,
  };
  const { status, data } = yield Api.post('oauth/token', requestData);
  if (status === 200) {
    yield put(loginSuccessAction(
      data.access_token,
      data.access_token,
      data.expires_in,
    ));
  } else {
    yield put(loginFailedAction());
  }
}

function* postLoginActions(action) {
  const d = new Date();
  const ts = d.getTime();
  localStorage.setItem('access_token', action.accessToken);
  localStorage.setItem('access_token', action.refreshToken);
  localStorage.setItem('expires_at', action.expiresIn * 1000 + ts);
  yield cookies.set(
    'access_token',
    action.accessToken,
  );
  yield put(tokenCheckAction());
}

function* postTokenSuccess(action) {
  yield localStorage.setItem('user', JSON.stringify(action.user));
  localStorage.setItem('access_token', action.accessToken);
  yield cookies.set(
    'access_token',
    action.accessToken,
  );
}

export default function* authSagas() {
  yield takeEvery(ACT_AUTH_TOKEN_CHECK, checkAuth);
  yield takeEvery(ACT_AUTH_LOGIN_ATTEMPT, attemptLogin);
  yield takeEvery(ACT_AUTH_LOGIN_SUCCESS, postLoginActions);
  yield takeEvery(ACT_AUTH_TOKEN_SUCCESS, postTokenSuccess);
  yield takeEvery(ACT_AUTH_TOKEN_FAIL, deleteToken);
  yield takeEvery(ACT_AUTH_LOGOUT_INIT, logout);
  yield put(tokenCheckAction());
}
